import { render, staticRenderFns } from "./overview-cell-link.vue?vue&type=template&id=3bbd622c&scoped=true"
import script from "./overview-cell-link.vue?vue&type=script&lang=ts"
export * from "./overview-cell-link.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd622c",
  null
  
)

export default component.exports